<template>
  <ion-content :class="`bills ${isDense ? 'dense' : ''}`">
    <!-- Client Name -->
    <ion-card-header :style="{ padding: '20px 8px' }">
      Cliente: {{ client.A1_NREDUZ || client.A1_NOME }}
    </ion-card-header>

    <!-- Loading -->
    <ion-grid v-if="!items" :style="{height: '25%'}">
      <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
        <ion-col size="12">
          <ion-label>Carregando itens</ion-label>
          <br/>
          <ion-spinner name="dots"></ion-spinner>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- No Data -->
    <ion-grid v-else-if="items && items.length == 0" :style="{height: '20%'}">
      <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
        <ion-col size="12">
          <ion-label>Sem registros.</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card class="card-bills" v-for="(item, index) in items" :key="index" :color="isDueDate({item}) ? 'error' : ''" :style="{ margin: '5px 10px 5px 5px' }">
      <ion-card-header @click="item.show = !item.show" :style="{ padding: '8px' }">
        <ion-grid class="ion-no-padding">
          <ion-row class="row-margin-bottom header">
            <ion-item class="ion-no-padding ion-no-margin" :style="{width: '100%', paddingBottom: '1px'}">
              <div
                class="ion-text-start"
                :style="{ fontSize: '0.7em', marginRight: '5px' }"
              >
                {{ computedHeadersMobile.filter(chm => chm.mobile.title).map(th => item[th.value]).join(' ') }}
              </div>
              <span v-for="(st, indexSt) in computedHeadersMobile.filter(chm => chm.mobile.subTitle)" :key="indexSt">
                {{ item[st.value] + ' ' }}
              </span>
              <ion-icon :size="isDense ? 'small': 'default'" class="ion-no-padding ion-no-margin" slot="end" :icon="(item.show) ? chevronUp : chevronDown"></ion-icon>
            </ion-item>
          </ion-row>
          <template v-if="!item.show">
            <!-- <hr :style="{ height: '.25px', width: '100%' }" color="grey" /> -->
            <ion-row class="ion-justify-content-between">
              <div v-for="(header, index) of computedAllHeaders.filter(h => !h.mobile || (h.mobile && !h.mobile.hidden))" :key="index" 
                :class="'inherit'">
                <ion-row class="ion-justify-content-center">
                  <small>{{ header.text }}</small>
                </ion-row>
                <ion-row class="ion-justify-content-center">
                  {{ formartFields({header, value: item[header.value]}) }} 
                </ion-row>
              </div>
            </ion-row>
          </template>
        </ion-grid>
      </ion-card-header>

      <template v-if="item.show">
        <ion-card-content 
          class="ion-no-padding">
          <ion-list class="ion-no-padding ion-no-margin">
            <template v-for="(header, index) in computedAllHeaders.filter(h => !h.mobile || (h.mobile && !h.mobile.hidden))" :key="index">
              <ion-item>
                <ion-row class="ion-justify-content-center">
                  {{ header.text }}: {{ formartFields({header, value: item[header.value]}) }} 
                </ion-row>
              </ion-item>
            </template>
          </ion-list>
          <ion-row>
            <ion-col  :style="{width: `${100/(computedCustomActions ? computedCustomActions.length : 1)}%`}" v-for="({data: cAction}, idx) of computedCustomActions" :key="`customActionBtn-${idx}`">
              <ion-button style="width: 100%"
                @click="clickAction({ item, customAction: cAction })">
                <!-- <ion-icon v-if="cAction.mobileIcon" class="ion-no-padding ion-no-margin" :icon="cAction.mobileIcon"></ion-icon>  -->
                {{ cAction.name }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </template>
    </ion-card>
  </ion-content>
</template>

<script>
import {
  createNamespacedHelpers,
  // mapActions,
  mapMutations,
  // mapState,
} from "vuex";
import {
  chevronDown, 
  chevronUp
} from "ionicons/icons";
import { jsPDF } from "jspdf";
import * as fs from "file-saver";
import "jspdf-autotable";
import {
  IonCard,
  // IonContent,
  IonCardContent,
  IonCardHeader,
  IonList,
  IonItem,
  IonGrid,
  IonLabel,
  IonRow,
  IonCol,
  IonContent,
  IonSpinner,
  // IonLabel,
  IonButton,
  IonIcon
} from "@ionic/vue";
const {
  // mapState: registersState,
  mapActions: registersActions,
  // mapMutations: registersMutations,
} = createNamespacedHelpers("registers");
const { mapState: authState } = createNamespacedHelpers("auth");
import store from "../store";
export default {
  components: {
    // IonContent,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonList,
    IonItem,
    IonGrid,
    IonLabel,
    IonRow,
    IonCol,
    IonSpinner,
    IonContent,
    // IonLabel,
    IonButton,
    IonIcon
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: "teal"
    },
    dueDateField: String,
    customActions: Object,
    client: Object,
    props: Object,
  },
  emits: [
    "dueDateEvent"
  ],
  data() {
    return {
      hasDebit: false,
      expand: false,
      itemsDueDate: [],
      titleHeader: [],
      subTitleHeader: [],
      jsPdf: {
        doc: null,
        dialog: false,
        sendEmail: {
          sending: false,
          dialog: false,
          inputs: [
            { type: "text-field", value: "to", label: "Email de Destino" },
            { type: "text-field", value: "cc", label: "Cc", md: 6 },
            { type: "text-field", value: "bcc", label: "Cco", md: 6 },
            { type: "text-field", value: "subject", label: "Assunto" },
            {
              type: "textarea",
              value: "text",
              label: "Corpo do Email",
              rows: 4,
            },
          ],
          model: null,
        },
        blob: null,
      },
    };
  },
  computed: {
    isDense() { return this.props.formDense },
    computedHasDebit(){
      return (this.items) ? this.items.some(i => this.isDueDate({item: i})) : false
    },
    computedExpand(){
      return this.expand
    },
    computedHeadersMobile() {
      return this.headers.filter(header => header.mobile)
    },
    computedCustomActions() {
      return this.customActions
    },
    computedAllHeaders() {
      return this.headers.filter(header => header.mobile && !(header.mobile.title || header.mobile.subTitle))
    }
  },
  methods: {
    ...registersActions([
      "getApi",
      "showToast"
    ]),
    ...mapMutations(["setLoading"]),
    ...authState(["user"]),

    /** @TODO parametrizar o nome do documento */
    savePdf({item}) {
      if (this.jsPdf.doc) this.jsPdf.doc.save(`${eval(this.titleOfPrint)}.pdf`);
      else if (this.jsPdf.blob) {
        fs.saveAs(this.jsPdf.blob, "Arquivo -" + new Date().valueOf() + ".pdf");
      }

      // console.warn("jsPdf.doc not yet defined.");
    },

    async generatePdf({base64str, objectStorage, url}) {
      if (!base64str && this.companySelected.groupCompany == 'decanter' && this.item.C5_NUM) {
        base64str = await this.pedidoDownload(this.item.C5_FILIAL +  '/' + this.item.C5_NUM)        
      } else if (!base64str && this.companySelected.groupCompany == 'decanter' && ( !this.item.status || this.item.status.trim() === 'Rascunho') ) {
        this.setLoading({stats: true})
        base64str = await this.imprimePedido()
      }

      if (!base64str && this.companySelected.groupCompany == 'samtronic' && this.item.CJ_NUM) {
        base64str = await this.orcamentoDownload(this.item.CJ_FILIAL +  '/' + this.item.CJ_NUM)        
      } else if(!base64str && this.companySelected.groupCompany == 'samtronic') {
        this.setLoading({stats: false})
        this.showToast({ message: 'Necessário enviar o orçamento para o Protheus antes de imprimir.', color: "warning" })
        return
      }
      
      this.setLoading({stats: true})

      if (url) this.jsPdf.url = url
      else if (objectStorage) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        
        xhr.onload = async (event) => {
          this.jsPdf.blob = xhr.response
          // this.jsPdf.doc = await this.blobTo64({blob: xhr.response})
          this.jsPdf.dialog = true
          this.setLoading({stats: false})
        };
        xhr.open('GET', objectStorage.documentUrl);
        xhr.send();
      }
      else if(base64str){
        // decode base64 string, remove space for IE compatibility
        var binary = atob(base64str.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        const doc = new jsPDF()
        var blob = new Blob( [view], { type: "application/pdf" });
        // const link = document.createElement('a')
        // link.href = URL.createObjectURL(blob)
        // link.click()
        

        // this.jsPdf.doc = blob
        // this.jsPdf.dialog = true
        this.jsPdf.blob = blob
        this.jsPdf.dialog = true
        this.savePdf({})
        this.setLoading({stats: false})
      }
      else {
        try {
          const doc = new jsPDF();
          const fontSize = 7
          let lineHeight = fontSize
          const fontFamily = "helvetica"
          const tableLineWidth = 0.2
          const tableLineColor = [125, 125, 125]
          const hexToNumber = str => eval('0x' + str)
          const fillColor = this.colorPdfTable && [
            hexToNumber(this.colorPdfTable.slice(1,3)),
            hexToNumber(this.colorPdfTable.slice(3,5)),
            hexToNumber(this.colorPdfTable.slice(5,7)),
          ] || [ 41, 128, 186] // azul padrão de header

          
          // altere o valor para determinar qual linha deve começar o documento
          let line = 2

          const size = {
            x: 210,
            y: 297 
          }

          const item = this.$refs.formMaster.getModel()

          /**
           * Logo
           * addImage ref: https://artskydj.github.io/jsPDF/docs/module-addImage.html
           */
          const image = await this.loadImage()
          doc.addImage(image, 'JPEG', 5, lineHeight, 16, 9)

          /**
           * Título
           */
          doc.setFont(fontFamily)
          doc.setFontSize(2.5 * fontSize)
          /** @TODO parametrizar o título */

          doc.text(eval(this.titleOfPrint || "'Impressão'"), size.x/2, line * lineHeight, { align: 'center' });
          doc.setFontSize(fontSize)
          line++

          /**
           * Empresa
           */
          const colsEmpresa = 3
          const company = this.company
          const empresaItems = this.printCompanyHeaders.map(pcH => {
            const valueCompiled = eval(pcH.value)
            return {...pcH, value: valueCompiled}
          })
          
          const empresaBody = []
          for (let row = 0; row < empresaItems.length / colsEmpresa; row++) {
            const rowInputs = empresaItems.slice(row*colsEmpresa, (row*colsEmpresa) + colsEmpresa)
            empresaBody.push(rowInputs.reduce((acc, item) => {
              const label = {
                content: item.label,
                styles: {
                  fillColor,
                  textColor: [255, 255, 255], 
                  fontStyle: 'bold',
                  lineWidth: 0.1,
                  lineColor: [171, 206, 228]
                },
              }
              const value = {
                content: item.value,
              }

              return [...acc, label, value]
            }, []))
          }
          doc.autoTable({
            startY: line * lineHeight,
            body: empresaBody,
            margin: { top: 25, right: 5, bottom: 10, left: 5 },
            styles: { halign: 'center', fontSize, cellPadding: 1 },
            headStyles: { halign: 'center', fontStyle: 'bold' },
            tableLineWidth,
            tableLineColor,
          })

          /**
           * Agrupar os inputMaster por quadrante de impressão
           */

          let inputMasterPerBox = []
          
          this.computedInputsMaster.filter(im => im.value && im.print && !im.returnObject).forEach(im => {
            const imBox = inputMasterPerBox[im.print.box - 1] || []
            inputMasterPerBox[im.print.box - 1] = [...imBox, im]
          })

          /**
           * Cabeçalho
           */
          // Define o número de colunas por tabela
          const cols = 3

          inputMasterPerBox.forEach(imBox => {
            const inputs = imBox.sort((a,b) => {
              if (a.print.order < b.print.order) {
                return -1
              }
              if (a.print.order > b.print.order) {
                return 1
              }
              return 0
            })

            const body = []

            for (let row = 0; row < inputs.length / cols; row++) {
              const rowInputs = inputs.slice(row*cols, (row*cols) + cols)
              body.push(rowInputs.reduce((acc, input) => {
                let text = item[input.value] || eval(`item.${input.value}`) || ''
                if (input.type == 'select') {
                  const selectItem = input.items.find(i => i.value == item[input.value])
                  if (selectItem) 
                    text = selectItem.text || item[input.value]
                } else if (input.type === 'switch') {
                  text = item[input.value] ? 'Sim' : 'Não'
                }
      
                /**
                * Configuração do Label
                * ref: https://github.com/simonbengtsson/jsPDF-AutoTable#options
                */
                const label = {
                  content: input.label,
                  styles: {
                    fillColor,
                    textColor: [255, 255, 255], 
                    fontStyle: 'bold',
                    lineWidth: 0.1,
                    lineColor: [171, 206, 228]
                  },
                }
                
                /**
                * Configuração do texto do valor do item
                */

                const value = typeof text === 'string' ? {content: text.trim()} : {content: text}
      
                return [...acc, label, value]
              }, []))
            }
            doc.autoTable({
              startY: doc.lastAutoTable.finalY + lineHeight,
              body,
              margin: { top: 25, right: 5, bottom: 10, left: 5 },
              styles: {
                fontSize,
                cellPadding: 1,
              },
              tableLineWidth,
              tableLineColor,
            })
          })
          
          /**
          * Impostos
          */
          if (this.impostos && this.impostos.headers && this.impostos.headers.length > 0) {
            const head = [
              [{ content: 'Impostos', colSpan: this.impostos.headers.length, styles: { halign: 'center' }}],
              this.impostos.headers.map(el => ({content:el.text}))
            ]
            const impostosBody = [this.impostos.headers.map(el => {
              const value = this.impostos.itens[0][el.value]
              return `R$ ${value.toLocaleString('pt-br', { minimumFractionDigits:2, maximumFractionDigits: 2 }) }`
            })]
            doc.autoTable({
              startY: doc.lastAutoTable.finalY + lineHeight,
              head,
              body: impostosBody,
              margin: { top: 25, right: 5, bottom: 10, left: 5 },
              styles: { halign: 'center', fontSize, fillColor, cellPadding: 1 },
              headStyles: { halign: 'center', fontStyle: 'bold' },
              tableLineWidth,
              tableLineColor,
            })

            if (this.impostosPdfText)
              doc.text(this.impostosPdfText, 5, doc.lastAutoTable.finalY + (lineHeight/2))
          }

          /**
          * Totais
          */
          this.docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor })

          /**
          * Tabela de itens
          */
          const headersItens = this.computedHeaders.filter(header => header.print).sort((h1, h2) => {
            if (h1.print.order < h2.print.order) {
              return -1
            }

            if (h1.print.order > h2.print.order) {
              return 1
            }

            return 0
          })
          const head = [headersItens.map(h => h.text)]
          const headKeys = headersItens.map(h => h.value)

          const itemsTable = this.$refs.formDetails?.getTable()
          if(itemsTable && itemsTable.length > 0){
            const bodyTableItems = []
            for (const item of itemsTable) {
              if (!this.filterItemsFunction(item))
                continue
              
              bodyTableItems.push(headKeys.map(header => typeof item[header] === 'string' ? item[header].trim() : item[header]))
            }

            // ref: https://github.com/simonbengtsson/jsPDF-AutoTable
            doc.autoTable({
              startY: doc.lastAutoTable.finalY + lineHeight,
              head,
              body: bodyTableItems,
              margin: { top: 25, right: 5, bottom: 10, left: 5 },
              styles: { fontSize, cellPadding: 1  },
              headStyles: { fontStyle: 'bold', fillColor, },
              tableLineWidth,
              tableLineColor,
            })
          }

          /**
          * Totais (fim da tabela)
          */
          this.docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor })

          this.jsPdf.doc = doc
          this.jsPdf.dialog = true
          this.savePdf({item})
        } catch(e) {
          console.error(e)
        } finally {
          this.setLoading({stats: false})
        }
      }
    },
    clickAction({ item, customAction }) {
      const self = {
        item,
        $router: store.$router,
        user: this.user,
        showToast: this.showToast,
        $api: this.$api,
        ...this,
      };
      const actionRunner = eval(customAction.actionRunner);
      actionRunner(self);
    },
    showDetails(item) {
      item.show = !item.show;
    },
    isDueDate({item}) {
      let today = store.$moment(new Date(), 'YYYYMMDD')
      today = today.format('YYYYMMDD')
      return  (item && item[this.dueDateField] && today) ? today.trim() > item[this.dueDateField].trim() : false
    },
    formartFields({header, value}){
      let maskedValue = ``

      const prefix = header.prefix ? header.prefix + ' ' : ''

      // valor numérico
      if (header.type == 'float' || header.type == 'integer') {
        maskedValue =  value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
      //data em formato string, geralmente como vem do Protheus (YYYYMMDD)
      } else if (header.date && !(value instanceof Date) && !isNaN(value) && typeof value === "string") {
        maskedValue = store.$moment(value, 'YYYYMMDD').format("DD/MM/YYYY");
      } else if (header.date && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("DD/MM/YYYY");
      }
      else if (header.dateHour && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("DD/MM/YYYY - HH:mm:ss");
      }
      else if (header.dateYear && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("YYYY");
      }
      else if (header.datePlusWeek && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("DD/MM/YYYY, dddd");
      } else {    
        maskedValue = value
      }

      const suffix = header.suffix
        ? ' ' + header.suffix
        : ''

      return prefix + maskedValue + suffix      
    }
  },
  setup() {
    return {
      chevronDown,
      chevronUp
    };
  },
  created() {
    if (this.computedHasDebit) {
      this.$emit('dueDateEvent', true)
    }
  }
  
};
</script>

<style scoped>
  .card-bills {
    margin: .1em;
  }
  ion-content.bills.dense {
    font-size: 0.7em;
  }
  ion-content.bills ion-list {
    background: transparent!important;
  }
  ion-content.bills ion-item::part(native) {
    background: transparent;
  }
  ion-content.bills.dense ion-item::part(native) {
    min-height: 0!important;
    font-size: 0.7em;
  }
</style>